import { useQuery } from '@apollo/client';
import type { UseUsersListFetch } from '@openx/components-administration/lib/utils/context/UserHookTypes.ts';
import { GetUsersListDocument } from '../../../../graphql/query/users/GetUsersList.generated.tsx';

export const useUsersListFetch: UseUsersListFetch = ({ onCompleted }) => {
  const {
    data: { user: users } = {},
    loading,
    error,
  } = useQuery(GetUsersListDocument, {
    onCompleted: ({ user_aggregate }) => onCompleted?.(user_aggregate.aggregate?.count),
  });

  return {
    error,
    loading,
    users:
      users?.map(user => ({
        ...user,
        name: `${user.first_name} ${user.last_name}`,
      })) ?? [],
  };
};
